<md-dialog>
	<div md-dialog-header>
		<md-icon icon="untitled-ui/general/info-circle"></md-icon>
		<span class="md-text-lg-semibold">Timeline Key</span>
	</div>

	<div class="legend-dialog__content">
		<section class="legend-section">
			<h3 class="legend-section__title">Lesson Status</h3>
			<ul class="legend-list">
				<li class="legend-item">
					<span class="legend-dot legend-dot--today-next">
						<md-icon icon="untitled-ui/maps/marker-pin-01"></md-icon>
					</span>
					<span class="legend-item__label">Today / Next Lesson</span>
				</li>
				<li class="legend-item">
					<span class="legend-dot legend-dot--current"></span>
					<span class="legend-item__label">Currently Viewing</span>
				</li>
				<li class="legend-item">
					<span class="legend-dot">
						<md-icon icon="untitled-ui/general/check-square-broken" class="legend-dot-icon--completed"></md-icon>
					</span>
					<span class="legend-item__label">Completed</span>
				</li>
				<li class="legend-item">
					<span class="legend-dot">
						<md-icon icon="untitled-ui/general/slash-circle-01" class="legend-dot-icon--absent"></md-icon>
					</span>
					<span class="legend-item__label">Absent</span>
				</li>
				<li class="legend-item">
					<span class="legend-dot legend-dot--warning">
						<md-icon icon="untitled-ui/time/clock-refresh"></md-icon>
					</span>
					<span class="legend-item__label">Pending Reschedule</span>
				</li>
				<li class="legend-item">
					<span class="legend-dot legend-dot--warning">
						<md-icon icon="untitled-ui/time/hourglass-01"></md-icon>
					</span>
					<span class="legend-item__label">Awaiting Payment</span>
				</li>
				<li class="legend-item">
					<span class="legend-dot legend-dot--attention">
						<md-icon icon="untitled-ui/alerts/alert-square"></md-icon>
					</span>
					<span class="legend-item__label">Needs Attention</span>
				</li>
				<li class="legend-item">
					<span class="legend-dot">
						<md-icon icon="untitled-ui/time/calendar"></md-icon>
					</span>
					<span class="legend-item__label">Scheduled</span>
				</li>
			</ul>
		</section>

		<section class="legend-section">
			<h3 class="legend-section__title">Lesson Type</h3>
			<ul class="legend-list">
				<li class="legend-item">
					<span class="legend-icon"><md-icon icon="untitled-ui/media/monitor-01"></md-icon></span>
					<span class="legend-item__label">Instructional</span>
				</li>
				<li class="legend-item">
					<span class="legend-icon"><md-icon icon="untitled-ui/general/target-05"></md-icon></span>
					<span class="legend-item__label">Mastery</span>
				</li>
				<li class="legend-item">
					<span class="legend-icon"><md-icon icon="untitled-ui/communication/message-circle-01"></md-icon></span>
					<span class="legend-item__label">Tutoring</span>
				</li>
				<li class="legend-item">
					<span class="legend-icon"><md-icon icon="mylb/bird-outline"></md-icon></span>
					<span class="legend-item__label">Chirp Room</span>
				</li>
			</ul>
		</section>

		<section class="legend-section">
			<h3 class="legend-section__title">Semester Milestones</h3>
			<ul class="legend-list">
				<li class="legend-item">
					<span class="legend-icon"><md-icon icon="untitled-ui/maps/rocket-02"></md-icon></span>
					<span class="legend-item__label">Semester Start</span>
				</li>
				<li class="legend-item">
					<span class="legend-icon"><md-icon icon="untitled-ui/shapes/star-01"></md-icon></span>
					<span class="legend-item__label">Mid Semester</span>
				</li>
				<li class="legend-item">
					<span class="legend-icon"><md-icon icon="untitled-ui/maps/flag-01"></md-icon></span>
					<span class="legend-item__label">Final</span>
				</li>
			</ul>
		</section>
	</div>

	<div md-dialog-footer>
		<button md-button (click)="close()">Close</button>
	</div>
</md-dialog>
